$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#LoadingStrip').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#LoadingStrip').hide('FadeOut');
	}, 1500);
}


import wixWindow from 'wix-window';
$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
  $w("#vectorImage8").show();
}

});